<template>
    <div class="scheduler">
        <!--<app-date-picker-field position="left"
                                class="date-picker"
                                :selectorDate="dateInput"/>
        <app-date-picker-in ></app-date-picker-in>-->
        <div class="dates-container">
            <div class="start-date">
                <label>
                    Start Date <span class="info_mark scheduler_utc start" title="" style="width: 10px;"></span>
                </label>
                <div class="pickers">
                    <date-picker :value="startDate" placeholder="YYYY/MM/DD" format="YYYY/MM/DD" :disabled="disableStartDate"  :disabled-date="notBeforeToday" @input="setHourComparingNow($event, startDate, true)">
                        <i class="picker-icon" slot="icon-calendar"><img alt="Alternate Text" src="../Scheduler/Images/calendar.svg" /></i>
                    </date-picker>
                    <date-picker :value="startDate" type="time" placeholder="hh:mm" :show-second="false" format="HH:mm"
                                 :disabled-time="notBeforeNow" :clearable="false" :disabled="disableStartDate" @input="setHour($event, true)"
                                 :time-picker-options="{start: '00:00', step:'01:00' , end: '23:30', format: 'HH:mm' }">
                        <i class="picker-icon" slot="icon-calendar"><img alt="Alternate Text" src="../Scheduler/Images/clock.svg" /></i>
                    </date-picker>
                </div>
            </div>
            <div class="arrow-seperator">
                <div class="top-arrow"></div>
                <div class="bottom-arrow"></div>
            </div>
            <div class="end-date">
                <label>End Date <span class="info_mark scheduler_utc end" title="" style="width: 10px;"></span> <span style="color: #838383; padding-left: 20px;"> *Optional</span></label>
                <div class="pickers">
                    <date-picker :value="endDate" placeholder="YYYY/MM/DD" format="YYYY/MM/DD" :disabled="disableEndDate" :disabled-date="notBeforeStartDay" :show-hour="true" @input="setHourComparingNow($event, endDate, false)">
                        <i class="picker-icon" slot="icon-calendar"><img alt="Alternate Text" src="../Scheduler/Images/calendar.svg" /></i>
                    </date-picker>
                    <date-picker :value="endDate" type="time" placeholder="hh:mm" :show-second="false" format="HH:mm"
                                 :disabled-time="notBeforeNow" :clearable="false" :disabled="disableEndDate" @input="setHour($event, false)"
                                 :time-picker-options="{start: '00:00', step:'01:00' , end: '23:30', format: 'HH:mm' }">
                        <i class="picker-icon" slot="icon-calendar"><img alt="Alternate Text" src="../Scheduler/Images/clock.svg" /></i>
                    </date-picker>
                </div>
            </div>
        </div>
    </div>
</template>



<script>
    import { mapGetters, mapMutations, mapActions } from 'vuex';
    import DatePicker from 'vue2-datepicker';
    //import AppDatePickerInput from '../../Common/RangeDatePicker/DatePickerInput.vue';

  export default {
        components: {
          DatePicker,
      //    AppDatePickerInput,
        },

        props: {
        },

        created() {
        },

        data() {
            return {
                dateInput: {
                  month: new Date().getMonth(),
                  year: new Date().getFullYear()
                },
                startDate: null,
                endDate: null,
                disableStartDate: false,
                disableEndDate: false,
            }
        },

        methods: {

            ...mapMutations([
                'setSchedulerStartDate',
                'setSchedulerEndDate',
            ]),

            ...mapActions([
                'saveSchedulerDates',
                'clearAllSchedulerDates',
            ]),

            notBeforeToday(date) {
                return date < new Date(new Date().setHours(0, 0, 0, 0));
            },

            notBeforeStartDay(date) {
                return this.startDate ? date < new Date(new Date(this.startDate).setHours(0, 0, 0, 0)) : date < new Date(new Date().setHours(0, 0, 0, 0));
            },

            notBeforeNow(date) {
                const tmpDate = date ? new Date(date.getTime()) : new Date();
                return (tmpDate.setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0)) && (date.getHours() < new Date().getHours() + 1);
            },

            setHourComparingNow(date, prevDate, start) {
                if (date) {
                    let tmpDate = new Date(date.getTime());
                    const tmpHour = (tmpDate.setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0) || !prevDate) && (!prevDate || (prevDate.getHours() < new Date().getHours()))
                        ? new Date().getHours() + 1 : prevDate.getHours();
                    tmpDate = new Date(date);
                    tmpDate.setHours(tmpHour, 0, 0, 0);
                    start ? this.startDate = tmpDate : this.endDate = tmpDate ;
                } else {
                    //this.startDate = null;
                    start ? this.startDate = null : this.endDate = null;
                }
                this.endDate = this.startDate >  this.endDate ? null : this.endDate;
                //start ? this.setSchedulerStartDate(this.startDate) : this.setSchedulerEndDate(this.endDate);
                setIsDirty();
                this.saveSchedulerDates({ startDate: this.startDate, endDate: this.endDate });
            },

            setHour(date, start) {
                if (date) {
                    let tmpDate = new Date(date.getTime());
                    let currentDate = new Date(start ? this.startDate : this.endDate);
                    tmpDate.setMinutes(0);
                    currentDate.setMinutes(0);
                    currentDate.setHours(tmpDate.getHours());
                    start ? this.startDate = currentDate : this.endDate = currentDate;
                }
                setIsDirty();
                this.saveSchedulerDates({ startDate: this.startDate, endDate: this.endDate });
            },

            setSchedulerEditMode() {
                if (this.startDate) {
                    this.disableStartDate = this.startDate < new Date(new Date());
                }
                if (this.endDate) {
                    this.disableEndDate = this.endDate < new Date(new Date());
                }
                this.saveSchedulerDates({ startDate: this.startDate, endDate: this.endDate });
            },

            setSchedulerDuplicateMode() {
                if (this.startDate) {
                    this.startDate = this.startDate < new Date(new Date()) ? null : this.startDate;
                }
                if (this.endDate) {
                    this.endDate = this.endDate < new Date(new Date()) ?  null : this.endDate;
                }
                this.saveSchedulerDates({ startDate: this.startDate, endDate: this.endDate });
            },

            clearSchedulerDates() {
                this.clearAllSchedulerDates();
            },

        },

        computed: {

            ...mapGetters([
                'schedulerStartDate',
                'schedulerEndDate',
            ]),

        },

        mounted() {
            this.$root.$on('clearSchedulerDates', this.clearSchedulerDates);
            if (this.schedulerStartDate || model.currentCampaignObj.schedulerStartDate) {
                let tmpDate = new Date(this.schedulerStartDate || (model.currentCampaignObj.schedulerStartDate + ' UTC'));
                var userTimezoneOffset = tmpDate.getTimezoneOffset() * 60000;
                this.startDate = new Date(tmpDate);
                //this.startDate = new Date(tmpDate.getTime() - userTimezoneOffset);
            }
            if (this.schedulerEndDate || model.currentCampaignObj.schedulerEndDate) {
                this.endDate = new Date(this.schedulerEndDate || (model.currentCampaignObj.schedulerEndDate + ' UTC'));
            }
            if (model.isEditCampaignMode) {
                this.setSchedulerEditMode();
            }
            if (model.isDuplicateCampaignMode) {
                this.setSchedulerDuplicateMode();
            }
        }
  }

</script>

<style lang="scss">
    .mx-icon-left:before, .mx-icon-right:before, .mx-icon-double-left:before, .mx-icon-double-right:before, .mx-icon-double-left:after, .mx-icon-double-right:after {
        content: "";
        position: relative;
        top: -1px;
        display: inline-block;
        width: 10px;
        height: 10px;
        vertical-align: middle;
        border-style: solid;
        border-color: currentColor;
        border-width: 2px 0 0 2px;
        border-radius: 1px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-transform-origin: center;
        transform-origin: center;
        -webkit-transform: rotate(-45deg) scale(0.7);
        transform: rotate(-45deg) scale(0.7)
    }

    .mx-icon-double-left:after {
        left: -4px
    }

    .mx-icon-double-right:before {
        left: 4px
    }

    .mx-icon-right:before, .mx-icon-double-right:before, .mx-icon-double-right:after {
        -webkit-transform: rotate(135deg) scale(0.7);
        transform: rotate(135deg) scale(0.7)
    }

    .mx-btn {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        line-height: 1;
        font-size: 14px;
        font-weight: 500;
        padding: 7px 15px;
        margin: 0;
        cursor: pointer;
        background-color: transparent;
        outline: none;
        border: 1px solid rgba(0,0,0,.1);
        border-radius: 4px;
        color: #73879c;
        white-space: nowrap
    }

        .mx-btn:hover {
            border-color: #1284e7;
            color: #1284e7
        }

    .mx-btn-text {
        border: 0;
        padding: 0 4px;
        text-align: left;
        line-height: inherit
    }

    .mx-scrollbar {
        height: 100%
    }

        .mx-scrollbar:hover .mx-scrollbar-track {
            opacity: 1
        }

    .mx-scrollbar-wrap {
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto
    }

    .mx-scrollbar-track {
        position: absolute;
        top: 2px;
        right: 2px;
        bottom: 2px;
        width: 6px;
        z-index: 1;
        border-radius: 4px;
        opacity: 0;
        -webkit-transition: opacity .24s ease-out;
        transition: opacity .24s ease-out
    }

        .mx-scrollbar-track .mx-scrollbar-thumb {
            position: absolute;
            width: 100%;
            height: 0;
            cursor: pointer;
            border-radius: inherit;
            background-color: rgba(144,147,153,.3);
            -webkit-transition: background-color .3s;
            transition: background-color .3s
        }

    .mx-zoom-in-down-enter-active, .mx-zoom-in-down-leave-active {
        opacity: 1;
        -webkit-transform: scaleY(1);
        transform: scaleY(1);
        -webkit-transition: opacity .3s cubic-bezier(0.23, 1, 0.32, 1),-webkit-transform .3s cubic-bezier(0.23, 1, 0.32, 1);
        transition: opacity .3s cubic-bezier(0.23, 1, 0.32, 1),-webkit-transform .3s cubic-bezier(0.23, 1, 0.32, 1);
        transition: transform .3s cubic-bezier(0.23, 1, 0.32, 1),opacity .3s cubic-bezier(0.23, 1, 0.32, 1);
        transition: transform .3s cubic-bezier(0.23, 1, 0.32, 1),opacity .3s cubic-bezier(0.23, 1, 0.32, 1),-webkit-transform .3s cubic-bezier(0.23, 1, 0.32, 1);
        -webkit-transform-origin: center top;
        transform-origin: center top
    }

    .mx-zoom-in-down-enter, .mx-zoom-in-down-enter-from, .mx-zoom-in-down-leave-to {
        opacity: 0;
        -webkit-transform: scaleY(0);
        transform: scaleY(0)
    }

    .mx-datepicker {
        position: relative;
        display: flex;
    }

        .mx-datepicker svg {
            width: 1em;
            height: 1em;
            vertical-align: -0.15em;
            fill: currentColor;
            overflow: hidden
        }

    .mx-datepicker-range {
        width: 320px
    }

    .mx-datepicker-inline {
        width: auto
    }

    .mx-input-wrapper {
        position: relative
    }

        .mx-input-wrapper .mx-icon-clear {
            display: none
        }

        .mx-input-wrapper:hover .mx-icon-clear {
            display: block
        }

            .mx-input-wrapper:hover .mx-icon-clear + .mx-icon-calendar {
                display: none
            }

    .mx-input {
        display: inline-block;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 100%;
        height: 34px;
        padding: 6px 30px;
        padding-left: 10px;
        font-size: 14px;
        line-height: 1.4;
        color: #555;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
        box-shadow: inset 0 1px 1px rgba(0,0,0,.075)
    }

        .mx-input:hover, .mx-input:focus {
            border-color: #409aff
        }

        .mx-input:disabled, .mx-input.disabled {
            color: #ccc;
            background-color: #f3f3f3;
            border-color: #ccc;
            cursor: not-allowed
        }

        .mx-input:focus {
            outline: none
        }

        .mx-input::-ms-clear {
            display: none
        }

    .mx-icon-calendar, .mx-icon-clear {
        position: absolute;
        top: 50%;
        left: 8px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        font-size: 16px;
        line-height: 1;
        color: rgba(0,0,0,.5);
        vertical-align: middle
    }

    .mx-icon-clear {
        cursor: pointer
    }

        .mx-icon-clear:hover {
            color: rgba(0,0,0,.8)
        }

    .mx-datepicker-main {
        font: 14px/1.5 "Helvetica Neue",Helvetica,Arial,"Microsoft Yahei",sans-serif;
        color: #73879c;
        background-color: #fff;
        border: 1px solid #e8e8e8
    }

    .mx-datepicker-popup {
        position: absolute;
        margin-top: 1px;
        margin-bottom: 1px;
        -webkit-box-shadow: 0 6px 12px rgba(0,0,0,.175);
        box-shadow: 0 6px 12px rgba(0,0,0,.175);
        z-index: 2001
    }

    .mx-datepicker-sidebar {
        float: left;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 100px;
        padding: 6px;
        overflow: auto
    }

        .mx-datepicker-sidebar + .mx-datepicker-content {
            margin-left: 100px;
            border-left: 1px solid #e8e8e8
        }

    .mx-datepicker-body {
        position: relative;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none
    }

    .mx-btn-shortcut {
        display: block;
        padding: 0 6px;
        line-height: 24px
    }

    .mx-range-wrapper {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex
    }

    @media(max-width: 750px) {
        .mx-range-wrapper {
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column
        }
    }

    .mx-datepicker-header {
        padding: 6px 8px;
        border-bottom: 1px solid #e8e8e8
    }

    .mx-datepicker-footer {
        padding: 6px 8px;
        text-align: right;
        border-top: 1px solid #e8e8e8
    }

    .mx-calendar {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 248px;
        padding: 6px 12px
    }

        .mx-calendar + .mx-calendar {
            border-left: 1px solid #e8e8e8
        }

    .mx-calendar-header, .mx-time-header {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        height: 34px;
        line-height: 34px;
        text-align: center;
        overflow: hidden
    }

    .mx-btn-icon-left, .mx-btn-icon-double-left {
        float: left
    }

    .mx-btn-icon-right, .mx-btn-icon-double-right {
        float: right
    }

    .mx-calendar-header-label {
        font-size: 14px
    }

    .mx-calendar-decade-separator {
        margin: 0 2px
    }

        .mx-calendar-decade-separator:after {
            content: "~"
        }

    .mx-calendar-content {
        position: relative;
        height: 224px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box
    }

        .mx-calendar-content .cell {
            cursor: pointer
        }

            .mx-calendar-content .cell:hover {
                color: #73879c;
                background-color: #f3f9fe
            }

            .mx-calendar-content .cell.active {
                color: #fff;
                background-color: #1284e7
            }

            .mx-calendar-content .cell.in-range, .mx-calendar-content .cell.hover-in-range {
                color: #73879c;
                background-color: #dbedfb
            }

            .mx-calendar-content .cell.disabled {
                cursor: not-allowed;
                color: #ccc;
                background-color: #f3f3f3
            }

    .mx-calendar-week-mode .mx-date-row {
        cursor: pointer
    }

        .mx-calendar-week-mode .mx-date-row:hover {
            background-color: #f3f9fe
        }

        .mx-calendar-week-mode .mx-date-row.mx-active-week {
            background-color: #dbedfb
        }

        .mx-calendar-week-mode .mx-date-row .cell:hover {
            color: inherit;
            background-color: transparent
        }

        .mx-calendar-week-mode .mx-date-row .cell.active {
            color: inherit;
            background-color: transparent
        }

    .mx-week-number {
        opacity: .5
    }

    .mx-table {
        table-layout: fixed;
        border-collapse: separate;
        border-spacing: 0;
        width: 100%;
        height: 100%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        text-align: center
    }

        .mx-table th {
            padding: 0;
            font-weight: 500;
            vertical-align: middle
        }

        .mx-table td {
            padding: 0;
            vertical-align: middle
        }

    .mx-table-date td, .mx-table-date th {
        height: 32px;
        font-size: 12px
    }

    .mx-table-date .today {
        color: #2a90e9
    }

    .mx-table-date .cell.not-current-month {
        color: #ccc;
        background: none
    }

    .mx-time {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        width: 224px;
        background: #fff
    }

        .mx-time + .mx-time {
            border-left: 1px solid #e8e8e8
        }

    .mx-calendar-time {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%
    }

    .mx-time-header {
        border-bottom: 1px solid #e8e8e8
    }

    .mx-time-content {
        height: 224px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        overflow: hidden
    }

    .mx-time-columns {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        width: 100%;
        height: 100%;
        overflow: hidden
    }

    .mx-time-column {
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        position: relative;
        border-left: 1px solid #e8e8e8;
        text-align: center
    }

        .mx-time-column:first-child {
            border-left: 0
        }

        .mx-time-column .mx-time-list {
            margin: 0;
            padding: 0;
            list-style: none
        }

            .mx-time-column .mx-time-list::after {
                content: "";
                display: block;
                height: 192px
            }

        .mx-time-column .mx-time-item {
            cursor: pointer;
            font-size: 12px;
            height: 32px;
            line-height: 32px
        }

            .mx-time-column .mx-time-item:hover {
                color: #73879c;
                background-color: #f3f9fe
            }

            .mx-time-column .mx-time-item.active {
                color: #1284e7;
                background-color: transparent;
                font-weight: 700
            }

            .mx-time-column .mx-time-item.disabled {
                cursor: not-allowed;
                color: #ccc;
                background-color: #f3f3f3
            }

    .mx-time-option {
        cursor: pointer;
        padding: 8px 10px;
        font-size: 14px;
        line-height: 20px
    }

        .mx-time-option:hover {
            color: #73879c;
            background-color: #f3f9fe
        }

        .mx-time-option.active {
            color: #1284e7;
            background-color: transparent;
            font-weight: 700
        }

        .mx-time-option.disabled {
            cursor: not-allowed;
            color: #ccc;
            background-color: #f3f3f3
        }

    .dates-container {
        display: flex;
        align-items: center;

        .start-date, .end-date {
            display: flex;
            flex-direction: column;
            .pickers{
                display: flex;
                margin-top: 5px;
            }
        }

        .mx-input {
            display: flex;
            padding: 8px 10px;
            padding-left: 30px;
            font-family: 'Arial', sans-serif;
            font-size: 15px;
            line-height: 16px;
            text-transform: uppercase;
        }

        .mx-datepicker:nth-child(odd) {
            .mx-input {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
        }

        .mx-datepicker:nth-child(even) {
            width: 100px;

            .mx-input {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
            }
        }

        .arrow-seperator {
            position: relative;
            width: 8px;
            height: 16px;
            background: #767676;
            margin: 20px 10px 0 10px;

            .top-arrow {
                width: 8px;
                height: 16px;
                position: absolute;
                top: -8px;
                right: -1px;
                background: #f5f5f3;
                transform: rotate(135deg);
            }

            .bottom-arrow {
                width: 8px;
                position: absolute;
                bottom: -8px;
                right: -1px;
                background: #f5f5f3;
                height: 16px;
                transform: rotate(45deg);
            }
        }

        .picker-icon {
            width: 16px;
            height: 16px;
            display: flex;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Campaign/Scheduler/Scheduler.vue